"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorySelectionList = exports.TitleHeader = void 0;
const react_1 = __importStar(require("react"));
const immutable_1 = require("immutable");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const QCard_1 = __importDefault(require("components/QCard"));
const QButton_1 = __importDefault(require("components/QButton"));
const QCloseBox_1 = __importDefault(require("components/QCloseBox"));
const utils_1 = require("utils/date/utils");
const selectors_1 = require("data/transactions/selectors");
const SuggestedBudgetItem_1 = __importDefault(require("./SuggestedBudgetItem"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TitleHeader = ({ classes }) => (<div className={classes.header}>
    <Typography_1.default variant="h5" className={classes.title}>
      Choose from your most used categories
    </Typography_1.default>
    <Typography_1.default variant="body1">
      Select a category to add to your budget.  An average amount from your previous transactions
      will be entered on your behalf.  After you select the items and save them, you can change the default amounts
      on the main edit screen.
    </Typography_1.default>
  </div>);
exports.TitleHeader = TitleHeader;
const CategorySelectionList = ({ classes, expenseNodes, incomeNodes }) => (<div style={{ overflowY: 'scroll' }}>
    <Typography_1.default variant="subtitle1" className={classes.sectionHeader}>
      INCOME
    </Typography_1.default>
    {incomeNodes}

    <Typography_1.default variant="subtitle1" className={classes.sectionHeader}>
      EXPENSES
    </Typography_1.default>
    {expenseNodes}
  </div>);
exports.CategorySelectionList = CategorySelectionList;
const qCards = {
    firstCard: {
        elementId: 'suggested-categories-checkbox-Category',
        edge: 'left',
        width: 284,
        height: 200,
        next: 'secondCard',
        title: 'Select All Categories',
        content: 'If you want to start from your most regularly used categories, click here to select all categories.  You can ' +
            'then de-select any that you do not want to include.',
    },
    secondCard: {
        elementId: 'cat-row-container: 0',
        edge: 'right',
        width: 284,
        height: 200,
        prev: 'firstCard',
        title: 'Suggested Amounts',
        content: 'The suggested amount is based on your past spending patterns.  Once you add the item, you will be ' +
            'able to edit the amounts on the main screen.',
    },
};
const MAX_LIST_SIZE = 20;
// @ts-expect-error: Only a void function can be called with the 'new' keyword.
const BudgetSuggestedCategories = ({ onAddItems, onClose, accountIds, currency, exclusionSet = new immutable_1.Set() }) => {
    // @ts-expect-error: Only a void function can be called with the 'new' keyword.
    const [selectedItems, setSelectedItems] = (0, react_1.useState)(new immutable_1.Set());
    const [qCardsOn, setQCardsOn] = (0, react_1.useState)(true);
    const popularCatsMonthlyAverage = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getPopularCatsMonthlyAverage)(state, { dateRange: (0, utils_1.getPredefinedRange)({ value: '12_MONTHS_PRIOR' }), sortByAmount: true }), react_redux_1.shallowEqual);
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const popularCatsList = (0, react_1.useMemo)(() => popularCatsMonthlyAverage.filter((x) => !exclusionSet.find((xcoa) => chart_of_accounts_1.chartOfAccountsUtils.coasAreEqual(xcoa, x.coa))).slice(0, MAX_LIST_SIZE), [exclusionSet, popularCatsMonthlyAverage]);
    const incomeCats = popularCatsList.filter((x) => categories_1.categoriesSelectors.isIncomeCat(null, x.coa.id));
    const expenseCats = popularCatsList.filter((x) => !categories_1.categoriesSelectors.isIncomeCat(null, x.coa.id));
    const { classes } = useStyles();
    const showHideItem = (id) => {
        const newSelectedItems = selectedItems.has(id) ? selectedItems.delete(id) : selectedItems.add(id);
        setSelectedItems(newSelectedItems);
    };
    const selectUnselectAll = () => {
        if (selectedItems.size === popularCatsList.size) {
            // @ts-expect-error: Only a void function can be called with the 'new' keyword.
            setSelectedItems(new immutable_1.Set());
        }
        else {
            // @ts-expect-error: Only a void function can be called with the 'new' keyword.
            setSelectedItems(new immutable_1.Set(popularCatsList.map((x) => x.coa.id)));
        }
    };
    const buildAddListFromIds = () => selectedItems.map((id) => {
        const catId = id;
        const node = popularCatsList.find((x) => x.coa.id === id);
        return ({
            coa: { type: 'CATEGORY', id: catId },
            amount: node ? Math.abs(node.monthlyAverage) : 0,
        });
    });
    const getInnerNodes = (name, nodes) => {
        const localNodeList = [];
        nodes.forEach((node, index) => {
            localNodeList.push(<react_1.Fragment key={`budgetNode:${name}:${node.key || (node.coa && node.coa.id)}`}>
          <div id={`cat-row-container: ${index}`}>
            <SuggestedBudgetItem_1.default item={node} selected={selectedItems.has(node.key || node.coa.id)} onChange={showHideItem} accountIds={accountIds} currency={currency}/>
          </div>
        </react_1.Fragment>);
        });
        return localNodeList;
    };
    return (<Dialog_1.default maxWidth="md" open onClose={onClose} classes={{ paperWidthMd: classes.dialogRoot }}>
      {!isEntitySharedUser &&
            <QCard_1.default open={qCardsOn} onClose={() => setQCardsOn(false)} cards={qCards} name="WFBudgetSetupSuggestedCats" initialCard="firstCard" classes={{ qcard: classes.qCard }}/>}
      <QCloseBox_1.default onClose={onClose} id="choose-budget-close-button"/>

      <exports.TitleHeader classes={classes}/>
      <Divider_1.default classes={{ root: classes.dividerRoot }}/>

      <SuggestedBudgetItem_1.default header selected={selectedItems.size === popularCatsList.size} onChange={selectUnselectAll} classesExternal={{ categoryRow: classes.headerRow }}/>

      <exports.CategorySelectionList classes={classes} incomeNodes={getInnerNodes('income', incomeCats)} expenseNodes={getInnerNodes('expense', expenseCats)}/>

      <DialogActions_1.default className={classes.dialogActions}>
        <QButton_1.default onClick={onClose} id="choose-budget-cancel">
          Cancel
        </QButton_1.default>
        <QButton_1.default disabled={selectedItems.size === 0} onClick={() => onAddItems(buildAddListFromIds())} id="add-items-to-budget-button">
          {`Add ${selectedItems.size} Items to Budget`}
        </QButton_1.default>
      </DialogActions_1.default>

    </Dialog_1.default>);
};
exports.default = BudgetSuggestedCategories;
